import { IconButton, Menu } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";

const MenuIconButton = ({ children, icon }: PropsWithChildren<{ icon: React.ReactNode }>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  return (
    <>
      <IconButton onClick={handleClick}>{icon}</IconButton>
      <Menu open={open} anchorEl={anchorEl} slotProps={{ paper: { sx: { minWidth: 200 } } }} onClose={handleClose}>
        {children}
      </Menu>
    </>
  );
};

export default MenuIconButton;
